export { default } from "./SectionCopyright";
